import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavTail = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 24 11",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0L9.17154 9.17157C10.7336 10.7337 13.2663 10.7337 14.8284 9.17158L24 0H0Z",
			fill: "currentColor"
		})
	});
};
export default SvgNavTail;
